const ONBOARDING_KEY_PREFIX = "finster_onboarding_completed";

export type OnboardingHost = "powerpoint" | "excel";

function normalizeUserKey(userId: string | null | undefined): string {
  const normalized = String(userId || "").trim().toLowerCase();
  if (!normalized) return "anonymous";
  return normalized.replace(/[^a-z0-9@._-]/g, "_").slice(0, 128);
}

function normalizeHost(host: OnboardingHost): string {
  return host.toLowerCase().replace(/[^a-z0-9]/g, "_").slice(0, 32) || "unknown";
}

function getOnboardingKey(host: OnboardingHost, userId: string | null | undefined): string {
  return `${ONBOARDING_KEY_PREFIX}:${normalizeHost(host)}:${normalizeUserKey(userId)}`;
}

export function hasCompletedOnboarding(
  host: OnboardingHost,
  userId: string | null | undefined
): boolean {
  if (typeof localStorage === "undefined") return false;
  try {
    return localStorage.getItem(getOnboardingKey(host, userId)) === "true";
  } catch {
    return false;
  }
}

export function markOnboardingCompleted(
  host: OnboardingHost,
  userId: string | null | undefined
): void {
  if (typeof localStorage === "undefined") return;
  try {
    localStorage.setItem(getOnboardingKey(host, userId), "true");
  } catch {
    // Ignore storage errors; onboarding should not block usage.
  }
}
